import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { getStoryHeadline, isExternalStory } from "../../../utils/story";
import Headline from "../../../atoms/Headline";
import { getPrayerTimeArticle } from "../../../../../api/utils";
import "./PrayerTimeArticle.m.css";

const StoryCard = ({ story }) => {
  const externalStoryUrl = isExternalStory(story);
  const href = externalStoryUrl || `/${story?.slug}`;
  const target = externalStoryUrl ? "_blank" : "_self";
  const type = "secondary";
  const headline = getStoryHeadline(story);
  return (
    <Link href={href} target={target} styleName="card-wrapper">
      <div styleName={`${type}-story-container`}>
        <div styleName={`${type}-story-box`}>
          <div styleName="arrow-left"></div>
          {headline && <Headline headline={headline} styleName={`${type}-headline`} />}
        </div>
      </div>
    </Link>
  );
};

const PrayerTimeArticle = () => {
  const [article, setArticle] = useState(null);

  useEffect(() => {
    const fetchPrayerTimeArticle = async () => {
      const { items } = await getPrayerTimeArticle();
      if (items && items?.length > 0) {
        setArticle(items);
      }
    };
    fetchPrayerTimeArticle();
  }, []);
  return (
    article?.length > 0 && (
      <div styleName="prayertime-articles">
        {article.map((ar, index) => {
          const { story } = ar;
          return <StoryCard story={story} showReadTime={true} showTimestamp={true} key={index} />;
        })}
      </div>
    )
  );
};
export default PrayerTimeArticle;
